var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncreaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60161 5.40962L12.5564 3.97302L11.3231 8.98226L9.78466 7.50534L7.30301 10.0904C7.21876 10.1781 7.10237 10.2277 6.98072 10.2277C6.85907 10.2277 6.74268 10.1781 6.65843 10.0904L4.83624 8.19227L2.15627 10.9839C1.98539 11.1619 1.70257 11.1677 1.52457 10.9968C1.34658 10.8259 1.34081 10.5431 1.51168 10.3651L4.51395 7.23775C4.5982 7.14999 4.71459 7.10039 4.83624 7.10039C4.95789 7.10039 5.07429 7.14999 5.15853 7.23775L6.98072 9.13586L9.14007 6.88654L7.60161 5.40962Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseIcon);
export default __webpack_public_path__ + "static/media/increaseIcon.5e5d528f071812cb588bac8907c53422.svg";
export { ForwardRef as ReactComponent };